import React from "react";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaRegClock,
} from "react-icons/fa";
import { MdLanguage } from "react-icons/md";
import ContectInfoIcon from "../assests/images/contect-info.png";
import EmailIcon from "../assests/images/email-icon.png";
import AddressIcon from "../assests/images/address-icon.png";
import LangIcon from "../assests/images/lang-icon.png";

const SelectedpartnerDetails = ({
  partner,
  religionOptions,
  casteOptions,
  communityOptions,
  languages,
  onBack,
}) => {
  return (
    <div className="agent-browse-detail-container">
      <button
        className="agent-browse-back-button click-effect"
        onClick={onBack}
      >
        ← Back
      </button>

      <div className="agent-browse-detail-card">
        <div className="agent-browse-header-section">
          <div className="">
            <h2 className="agent-browse-partner?-name">
              {partner?.BusinessName}
            </h2>
            <div className="agent-browse-rating">
              {"\u2605".repeat(partner?.Rateings)}
              {"\u2606".repeat(5 - partner?.Rateings)}
            </div>
            <div className="d-flex gap-4">
              <div className="agent-browse-subinfo">
                <FaMapMarkerAlt /> {partner?.User?.Address?.CityId},{" "}
                {partner?.User?.Address?.CountryId}
              </div>
              <div className="agent-browse-subinfo">
                <img className="icons-for-partner" src={LangIcon} alt="" />
                {(() => {
                  const matchedLanguages = languages.filter((item) =>
                    partner.LanguagesServe.includes(item.LangId),
                  );
                  const visibleLanguages = matchedLanguages.slice(0, 2);
                  const remainingCount =
                    matchedLanguages.length - visibleLanguages.length;

                  return (
                    <>
                      {visibleLanguages.map((item) => (
                        <span key={item.LangId}>{item.LangDesc}</span>
                      ))}
                      {remainingCount > 0 && (
                        <span> +{remainingCount} more</span>
                      )}
                    </>
                  );
                })()}
              </div>
              <div className="agent-browse-subinfo">
                <FaRegClock /> {partner?.BusinessExperience + " years"}
              </div>
            </div>
          </div>
          <div className="agent-browse-owner-info">
            <div className="agent-browse-owner-name-box">
              <p className="agent-browse-owner-name">
                {partner?.BusinessName || "Agent"}
              </p>
            </div>

            <div className="agent-browse-owner-contact-box d-flex gap-2">
              <p className="agent-browse-owner-tag">
                {partner?.User?.PhoneNumber
                  ? "Owner phone number:"
                  : partner?.User?.EMail
                    ? "Owner email:"
                    : ""}
              </p>

              <p className="agent-browse-owner-number">
                {partner?.User?.PhoneNumber &&
                  `${partner.User.CountyCode} ${partner.User.PhoneNumber}`}

                {!partner?.User?.PhoneNumber &&
                  partner?.User?.EMail &&
                  partner.User.EMail}
              </p>
            </div>
          </div>
        </div>

        <div className="agent-browse-saperator-line mt-4"></div>

        <div className="agent-browse-section">
          <h4>About</h4>
          <p>{partner?.BusinessDescription}</p>
        </div>

        <div className="agent-browse-info-boxes">
          <div className="agent-browse-box2">
            <h5> Service Details</h5>
            <div className="agent-browse-label">Religions</div>
            <div className="agent-browse-tags">
              {partner.ReligionsServe?.includes("all") ? (
                <span className="agent-browse-tag">All Religions</span>
              ) : (
                religionOptions
                  .filter((item) =>
                    partner.ReligionsServe?.includes(item.value),
                  )
                  .map((rel, i) => (
                    <span key={i} className="agent-browse-tag">
                      {rel.label}
                    </span>
                  ))
              )}
            </div>
            <div className="agent-browse-label">Castes</div>
            <div className="agent-browse-tags">
              {partner.CastesServe?.includes("all") ? (
                <span className="agent-browse-tag">All Castes</span>
              ) : (
                casteOptions
                  .filter((item) => partner.CastesServe?.includes(item.value))
                  .map((cast, i) => (
                    <span key={i} className="agent-browse-tag">
                      {cast.label}
                    </span>
                  ))
              )}
            </div>

            <div className="agent-browse-label">Communities</div>
            <div className="agent-browse-tags">
              {partner.CommunitesServe?.includes("all") ? (
                <span className="agent-browse-tag">All Communities</span>
              ) : (
                communityOptions
                  .filter((item) =>
                    partner.CommunitesServe?.includes(item.value),
                  )
                  .map((comm, i) => (
                    <span key={i} className="agent-browse-tag">
                      {comm.label}
                    </span>
                  ))
              )}
            </div>
          </div>

          <div className="agent-browse-box2">
            <h5>Agency Details</h5>
            <div className="agent-browse-subinfo">
              <img src={ContectInfoIcon} className="agent-det-icons" alt="" />{" "}
              <span> {partner.User.PhoneNumber}</span>
            </div>
            <div className="agent-browse-subinfo">
              <img src={EmailIcon} className="agent-det-icons" alt="" />
              <span className="agent-browse-email">
                {" - "}
                {partner?.User?.EMail}
              </span>
            </div>
            <div className="agent-browse-subinfo">
              <img src={AddressIcon} className="agent-det-icons" alt="" />{" "}
              <span> {partner.BusinessAddress} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectedpartnerDetails;
